// routes/AdminRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";

import AdminDashboard from "../pages/AdminPortalPages/AdminDashboard";
import PortfolioPage from "../pages/AdminPortalPages/PortfolioPage";
import SkillQuestionsMapping from "../pages/AdminPortalPages/SkillQuestionMappingPage";
import SkillQuestionsPage from "../pages/AdminPortalPages/SkillQuestionsPage";
import AddQuestionPage from "../pages/AdminPortalPages/AddQuestionPage";
import ManageLearningPaths from "../pages/AdminPortalPages/ManageLearningPaths";
import AddLearningPath from "../pages/AdminPortalPages/AddLearningPath";
import ManageCoursesPage from "../pages/AdminPortalPages/ManageCoursesPage";
import ViewCourses from "../pages/AdminPortalPages/ViewCourses";

const AdminRoutes = (
  <>
    <Route path="/admin/dashboard" element={<AdminDashboard />} />
    <Route path="/admin/portfolio/:portfolio_id" element={<PortfolioPage />} />
    <Route
      path="/admin/portfolio/:portfolio_id/manage-courses"
      element={<ManageCoursesPage />}
    />
    <Route
      path="/admin/portfolio/:portfolio_id/learning-paths"
      element={<ManageLearningPaths />}
    />
    <Route
      path="/admin/portfolio/:portfolio_id/add-learning-path"
      element={<AddLearningPath />}
    />
    <Route
      path="/admin/portfolio/:portfolio_id/skill-question"
      element={<SkillQuestionsMapping />}
    />
    <Route
      path="/admin/portfolio/:portfolio_id/skill-question/:skillId"
      element={<SkillQuestionsPage />}
    />
    <Route
      path="/admin/portfolio/:portfolio_id/skill-question/:skillId/add-question"
      element={<AddQuestionPage />}
    />
    <Route
      path="/admin/portfolio/:portfolio_id/learning-path/:learning_path_id/courses"
      element={<ViewCourses />}
    />
  </>
);

export default AdminRoutes;
